/**
 * ChannelSeparator Component
 * Displays a separator when channel changes
 */

import { MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ChannelSeparatorProps {
  channelName: string;
  className?: string;
}

export const ChannelSeparator = ({ channelName, className }: ChannelSeparatorProps) => {
  return (
    <div className={cn('flex items-center justify-center my-6', className)}>
      <div className='flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-full border border-gray-200'>
        <MessageSquare className='h-4 w-4 text-muted-foreground' />
        <span className='text-sm font-medium text-muted-foreground'>{channelName}</span>
      </div>
    </div>
  );
};
